import { APIError } from 'helpers/Rest';

export const persistProject = (action) => async (dispatch, _g, {repository}) => {
  try {
    return _.tap(await dispatch(action), () => repository.persistProject(true));
  } catch (e) {
    if (e instanceof APIError) {
      console.warn(e);
    } else {
      throw e;
    }
  }
};
